import "./UserFiltersComponent.scss";
import * as Yup from "yup";
import React, {useCallback, useEffect, useRef, useState} from "react";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../store/reducers";
import {Field, FieldProps, Form, Formik, FormikProps, FormikValues} from "formik";
import CommonService from "../../../shared/services/common.service";
import HeadingComponent from "../../../shared/components/heading/headingComponent";
import FormikAutoCompleteDropdown
    from "../../../shared/components/core/formik-auto-complete-dropdown/formikAutoCompleteDropdown";
import FormikDatePickerComponent from "../../../shared/components/core/formik-date-picker/FormikDatePickerComponent";
import formValidationRules from "../../../shared/services/validation.service";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";

interface UserFiltersComponentProps {
    filtersData: any;
    onFiltersApply: (filterData: any) => void;
    clearAllFilters:()=>void;
}

const validationSchema = Yup.object().shape({
    startDate: Yup.mixed().nullable().when("endDate", {
        is: (endDate: Date) => {
            return Boolean(endDate)
        },
        then: Yup.mixed().nullable().required("Start date is required"),
        otherwise: Yup.mixed().nullable().notRequired()
    }),
    endDate: Yup.mixed().nullable().when("startDate", {
        is: (startDate: Date) => {
            return Boolean(startDate)
        },
        then: Yup.mixed().nullable().required("End date is required"),
        otherwise: Yup.mixed().nullable().notRequired()
    })
}, [['startDate', 'endDate']]);

const UserFiltersComponent = (props: UserFiltersComponentProps) => {

    const {filtersData, onFiltersApply,clearAllFilters} = props;
    const [dataFiltersInitialState, setDataFiltersInitialState] = useState(filtersData);
    const formikRef = useRef<FormikProps<FormikValues>>(null);
    const {roleList} = useSelector((state: IRootReducerState) => state.staticData);
    const onFiltersApplyHandler = useCallback((values: any) => {
        const payload = {
            ...values
        }
        payload.genders = payload.gendersObjs.map((item: any) => item.code);
        payload.roleIds = payload.roleObjs.map((item: any) => item.id);
        payload.startDate = payload.startDate ? CommonService.convertDateFormat(values['startDate'], 'YYYY-MM-DD') : "";
        payload.endDate = payload.endDate ? CommonService.convertDateFormat(values['endDate'], 'YYYY-MM-DD') : "";
        onFiltersApply(payload);
    }, [onFiltersApply]);

    useEffect(() => {
        setDataFiltersInitialState(filtersData);
    }, [filtersData]);

    return (
        <div className={'user-filters-component screen t-form-screen'}>
            <>
                <div className="drawer-sub-header horizontal-vertical-center-align">
                    <HeadingComponent title={"Filters"}/>
                    <div className={'filters-clear-all-button'}
                         onClick={() => {
                             formikRef.current && formikRef.current.resetForm();
                             clearAllFilters();
                         }}
                    >
                        Clear all
                    </div>
                </div>
                <div className="t-form t-form-drawer">
                    <Formik
                        initialValues={dataFiltersInitialState}
                        enableReinitialize={true}
                        onSubmit={onFiltersApplyHandler}
                        innerRef={formikRef}
                        validationSchema={validationSchema}
                    >
                        {({isSubmitting, values, isValid, setFieldValue, validateForm, errors,dirty}) => {
                            // eslint-disable-next-line react-hooks/rules-of-hooks
                            useEffect(() => {
                                validateForm();
                            }, [values, validateForm]);
                            return (
                                <Form noValidate={true} className={"patient-filters-holder"}>
                                    <div className="t-form-controls-wrapper">
                                        <Field name={'roleObjs'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikAutoCompleteDropdown
                                                        label={'Role'}
                                                        placeholder={'Select role'}
                                                        valueKey={'code'}
                                                        multiple={true}
                                                        data={roleList}
                                                        formikField={field}
                                                        getOptionLabel={(option => (option.role) || '')}
                                                    />
                                                )
                                            }
                                        </Field>
                                        <Field name={'gendersObjs'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikAutoCompleteDropdown
                                                        label={'Gender'}
                                                        placeholder={'Select gender'}
                                                        valueKey={'code'}
                                                        multiple={true}
                                                        data={CommonService._staticData.genderOptions}
                                                        formikField={field}
                                                        getOptionLabel={(option => (option.title) || '')}
                                                    />
                                                )
                                            }
                                        </Field>

                                        <Field name={'startDate'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikDatePickerComponent
                                                        label={'Start Date'}
                                                        formikField={field}
                                                        placeholder={'Select End Date'}
                                                        maxDate={formValidationRules.today}
                                                    />
                                                )
                                            }
                                        </Field>

                                        <Field name={'endDate'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikDatePickerComponent
                                                        label={'End Date'}
                                                        formikField={field}
                                                        placeholder={'Select End Date'}
                                                        maxDate={formValidationRules.today}
                                                    />
                                                )
                                            }
                                        </Field>

                                    </div>
                                    <div className="drawer-actions form-action-section">
                                        <ButtonComponent variant={"contained"}
                                                         fullWidth={true}
                                                         type={"submit"}
                                                         disabled={!isValid||!dirty}
                                        >
                                            Apply
                                        </ButtonComponent>
                                    </div>
                                </Form>
                            )
                        }
                        }
                    </Formik>
                </div>
            </>
        </div>
    );

};

export default UserFiltersComponent;
